var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailsFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0011 18.2241L6.90159 20.8865C6.16756 21.2697 5.31245 20.6458 5.45338 19.8298L6.4257 14.2001L2.30559 10.2119C1.70857 9.63404 2.03589 8.62234 2.85828 8.50367L8.55791 7.68123L11.1056 2.55495C11.4733 1.81502 12.5289 1.81502 12.8966 2.55495L15.4443 7.68123L21.1439 8.50367C21.9663 8.62234 22.2936 9.63404 21.6966 10.2119L17.5765 14.2001L18.5488 19.8298C18.6897 20.6458 17.8346 21.2697 17.1006 20.8865L12.0011 18.2241ZM11.5383 16.2096C11.8283 16.0582 12.1739 16.0582 12.4639 16.2096L16.2339 18.1778L15.5157 14.0195C15.4594 13.6936 15.5679 13.3609 15.8056 13.1308L18.8415 10.1921L14.6394 9.5858C14.3143 9.53889 14.0329 9.33528 13.8867 9.04111L12.0011 5.24693L10.1154 9.04111C9.96925 9.33528 9.68789 9.53889 9.36276 9.5858L5.16073 10.1921L8.19661 13.1308C8.43427 13.3609 8.5428 13.6936 8.48651 14.0195L7.76831 18.1778L11.5383 16.2096Z",
    fill: "#92929D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsFavorite);
export default __webpack_public_path__ + "static/media/DetailsFavorite.c18c18a681d231c1ee77174fedc45137.svg";
export { ForwardRef as ReactComponent };